var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.progress !== undefined)?_c('v-flex',{staticClass:"progress",attrs:{"shrink":""}},[_c('v-progress-linear',{class:_vm.status === 'finished' ? 'progressFinished' : '',attrs:{"height":"3","color":""},model:{value:(_vm.progress),callback:function ($$v) {_vm.progress=$$v},expression:"progress"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }